import { ReactNode } from "react";

import { FlexContainer } from "layouts/FlexContainer";

import { CondominiumTabs } from "components/Condominiums/CondominiumTabs";

interface Props {
  tabIndex: number;
  children: ReactNode;
}

export const CondominiumTabsProvider = ({ tabIndex, children }: Props) => {
  return (
    <FlexContainer>
      <CondominiumTabs tabIndex={tabIndex}>
        {children}
      </CondominiumTabs>
    </FlexContainer>
  );
};
